import { useState } from 'react';
import PropTypes from 'prop-types';
import { toAudString } from 'utils/currency';
import { asPerformanceDate, asTimeISO } from 'utils/date-formatter';
import { Link } from 'components/UI/Link/Link';
import { RemoveSeatsPrompt } from 'components/Cart/Prompts/RemoveSeatsPrompt';
import { AccordionCollapsible } from 'components/UI/Accordion/AccordionCollapsible';

export const StandardEventSummary = (props) => {
  const { performanceTicket, allowRemove, stepName } = props;
  const {
    TicketedItems,
    PerformanceDescription,
    PerformanceId,
    Venue,
    ShowDateTime,
    PerformanceDate,
    IsoPerformanceDate,
    PerformanceTotal,
    EventUrl,
  } = performanceTicket;

  const [collapseIsActive, setcollapseIsActive] = useState(false);
  const [removeEvent, setRemoveEvent] = useState(null);

  const showPrompt = (event) => {
    setRemoveEvent({
      ...event,
      EventUrl,
    });
  };

  const handleShowDetails = (event) => {
    event.preventDefault();
    setcollapseIsActive((prev) => !prev);
  };

  const eventDate = ShowDateTime ? (
    <span>
      {asPerformanceDate(PerformanceDate)} at {asTimeISO(IsoPerformanceDate || PerformanceDate)}
    </span>
  ) : (
    <span>{asPerformanceDate(PerformanceDate)}</span>
  );

  const renderSublineItems = (sublineItems, isSeated) =>
    sublineItems.map((seat, index) => (
      <div key={index}>
        <hr />
        <div className="row">
          <div className="col-xs-4">
            <span className="info-label">Seat</span>
          </div>
          <div className="col-xs-8">{isSeated ? `${seat.SeatRow}${seat.SeatNumber}` : ''}</div>
        </div>
        <div className="row">
          <div className="col-xs-4">
            <span className="info-label">Section</span>
          </div>
          <div className="col-xs-8">{seat.SectionShortDescription}</div>
        </div>
        <div className="row">
          <div className="col-xs-4">
            <span className="info-label">Zone</span>
          </div>
          <div className="col-xs-8">{seat.ZoneDescription}</div>
        </div>
        <div className="row">
          <div className="col-xs-4">
            <span className="info-label">Type</span>
          </div>
          {seat.SeatTypeAliasDescription ? (
            <div className="col-xs-8">{seat.SeatTypeAliasDescription}</div>
          ) : (
            <div className="col-xs-8">{seat.SeatTypeDescription}</div>
          )}
        </div>
        {seat.OrignalAmount > 0 && seat.OrignalAmount > seat.AmountDue && (
          <div className="row">
            <div className="col-xs-4">
              <span className="info-label">Original price</span>
            </div>
            <div className="col-xs-8">
              <span className="price-old">{toAudString(seat.OrignalAmount)}</span>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-xs-4">
            <span className="info-label">Price</span>
          </div>
          <div className="col-xs-8">{toAudString(seat.AmountDue)}</div>
        </div>
      </div>
    ));

  return (
    <>
      <RemoveSeatsPrompt
        active={!!removeEvent}
        event={removeEvent}
        stepName={stepName}
        onRequestClose={() => {
          setRemoveEvent(null);
        }}
      />

      <p>
        <strong className="show-name">{PerformanceDescription}</strong>
      </p>
      <div className="panel" role="tab">
        <a
          href="#"
          onClick={handleShowDetails}
          className="link-bold link-toggle-down collapsed"
          role="button"
        >
          Show details
        </a>

        <AccordionCollapsible
          id={`collapse-${PerformanceId}`}
          extendClass="delivery-order-summary"
          isActive={collapseIsActive}
        >
          <span className="info-label">{Venue}</span>
          <br />
          {eventDate}

          {TicketedItems.map((ticketedItem, index) => (
            <div key={index}>
              {renderSublineItems(ticketedItem.SubLineItems, ticketedItem.IsSeated)}

              {allowRemove && (
                <Link
                  href="#"
                  noUnderline
                  onClick={() => showPrompt(ticketedItem)}
                  variant="secondary"
                  extendClass="link-bold link-remove"
                >
                  Remove seats
                </Link>
              )}
            </div>
          ))}
        </AccordionCollapsible>
      </div>

      <div className="text-right subtotal">
        <span className="info-label">Performance Subtotal</span>
        <br />
        {toAudString(PerformanceTotal)}
      </div>
      <hr />
    </>
  );
};

StandardEventSummary.propTypes = {
  performanceTicket: PropTypes.object,
  allowRemove: PropTypes.bool,
  stepName: PropTypes.string,
};
